module.exports = __webpack_public_path__ + "static/media/spring.2940b55c.png";